import { type MetaArgs, type MetaDescriptor } from '@remix-run/node';

import {
  getPathnameWithLocale,
  getPathnameWithoutLocale,
} from '@/utils/urlUtils';
import i18n from '~/i18n';
import type { RootLoader } from '~/root';

export const getSeoLinks = ({
  location,
  matches,
  params,
}: Pick<
  MetaArgs<
    unknown,
    {
      root: RootLoader;
    }
  >,
  'location' | 'matches' | 'params'
>): MetaDescriptor[] => {
  const rootLoaderData = matches.find((match) => match.id === 'root')?.data;

  if (!rootLoaderData) {
    return [];
  }

  const { requestUrl } = rootLoaderData;
  const url = new URL(requestUrl);
  url.protocol = 'https:';
  const base = url.origin;
  const pathname = getPathnameWithoutLocale(location.pathname);
  const { lang } = params;

  return [
    {
      tagName: 'link',
      rel: 'canonical',
      href: new URL(getPathnameWithLocale(pathname, lang), base).toString(),
    },
    {
      tagName: 'link',
      rel: 'alternate',
      hrefLang: 'x-default',
      href: new URL(
        getPathnameWithLocale(pathname, undefined),
        base,
      ).toString(),
    },
    ...i18n.supportedLngs.map((locale) => {
      return {
        tagName: 'link',
        rel: 'alternate',
        hrefLang: locale,
        href: new URL(getPathnameWithLocale(pathname, locale), base).toString(),
      };
    }),
  ];
};
